import classnames from 'classnames'
import React from 'react'
import {useSelectedVariantContext} from '../context/SelectedVariantContext'
import {replaceUnderline} from '../context/SelectedVariantContext/helper'
import {actionChangeTabDesign, updateActiveSide} from '../context/SelectedVariantContext/action'
import {useEditorSides} from '../../../hooks/useEditorSides'
import {isBackofficeEnv} from '../../../helpers/isBackoffceEnv'

const SwitchBetweenSides = () => {
    const {
        state: {selectedSide, display, runningImageCompress, isAdmin, productCreatedType, cropMode},
        dispatch,
    } = useSelectedVariantContext()
    const {sides} = useEditorSides()

    const changeSide = async (tab) => {
        if (tab === selectedSide) return
        dispatch(updateActiveSide(tab))
        dispatch(actionChangeTabDesign(''))
    }

    const switchBtnStyles = 'Side text-base text-text-primary border-gray-300'

    return (
        <div className="SwitchBetweenSides">
            {display === 'design' && (
                <div className="Sides" id={'switch_sides'}>
                    {sides?.map((sideType) => (
                        <button
                            type="button"
                            key={sideType}
                            className={classnames(switchBtnStyles, {
                                active: selectedSide === sideType,
                                'text-white': selectedSide === sideType,
                            })}
                            onClick={() => {
                                changeSide(sideType)
                            }}
                            disabled={runningImageCompress || cropMode}
                        >
                            {replaceUnderline(sideType)}
                        </button>
                    ))}

                    {productCreatedType !== 'regularNoTemplate' &&
                        productCreatedType !== 'type2D' &&
                        productCreatedType !== 'combineLayout' && (
                            <>
                                <button
                                    type="button"
                                    className={classnames(`${switchBtnStyles} AllAreas`, {
                                        active: selectedSide === 'All',
                                    })}
                                    onClick={() => {
                                        changeSide('All')
                                    }}
                                    id="all_areas"
                                    disabled={runningImageCompress || cropMode}
                                >
                                    All Areas (view only)
                                </button>

                                {isAdmin && isBackofficeEnv() && (
                                    <button
                                        type="button"
                                        className={classnames(`${switchBtnStyles}  AllAreas`, {
                                            active: selectedSide === 'Safezone',
                                        })}
                                        onClick={() => {
                                            changeSide('Safezone')
                                        }}
                                        disabled={runningImageCompress}
                                    >
                                        Safe zone
                                    </button>
                                )}
                            </>
                        )}
                </div>
            )}
        </div>
    )
}

export default SwitchBetweenSides
